import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { Container, Content, StyledTitle } from '../SelectEdit/SelectEdit.styles';
import withTranslation from "../WithTranslation/WithTranslation";
import styled from 'styled-components';

const RangeLabels = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-top: 8px;
  margin-bottom: 8px;
`;

class RangeEdit extends React.Component {
  static propTypes = {
    loading: PropTypes.bool,
    nested: PropTypes.bool,
    selected: PropTypes.number,
    title: PropTypes.string,
    onChange: PropTypes.func,
    t: PropTypes.func.isRequired,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    step: PropTypes.number,
    unit: PropTypes.string,
  };

  static defaultProps = {
    nested: false,
    selected: null,
    onChange: () => {},
    loading: false,
    title: null,
    step: 1,
    unit: '',
  };

  handleChange = (e) => {
    const value = Number(e.target.value);
    this.props.onChange(value);
  };

  componentDidUpdate(prevProps) {
    const { min, max, selected, onChange, step } = this.props;

    // reaguj, kiedy zmienia się zakres lub selected
    const rangeChanged = prevProps.min !== min || prevProps.max !== max;
    const selectedChanged = prevProps.selected !== selected;

    if (!rangeChanged && !selectedChanged) return;

    // aktualna wartość (zabezpieczenie przed null/NaN)
    let value =
      typeof selected === 'number' && !Number.isNaN(selected)
        ? selected
        : min;

    // jeśli poza zakresem → wybierz bliższą granicę
    if (value < min || value > max) {
      const distToMin = Math.abs(value - min);
      const distToMax = Math.abs(value - max);
      value = distToMin <= distToMax ? min : max;
    }

    // opcjonalnie: dociągnięcie do siatki step (najbliższy krok)
    if (step && step > 0) {
      const stepsFromMin = Math.round((value - min) / step);
      const snapped = min + stepsFromMin * step;
      // jeszcze raz clamp na wszelki wypadek
      value = Math.min(Math.max(snapped, min), max);
    }

    // unikamy pętli – wołamy onChange tylko gdy faktycznie zmieniamy wartość
    if (value !== selected) {
      onChange(value);
    }
  }

  render() {
    const { loading, nested, title, min, max, step, selected, unit } = this.props;

    return (
      <Spin spinning={loading}>
        <Container nested={nested}>
          <Content style={{ width: '100%' }}>
            {title && <StyledTitle>{title}:</StyledTitle>}
            <div style={{ width: '100%', display: 'flex' }}>
              <RangeLabels>
                <span style={{ whiteSpace: 'nowrap' }}>
                  {min} {unit ?? ''}
                </span>
              </RangeLabels>

              <div style={{ position: 'relative', width: '100%', marginTop: '8px' }}>
                <div
                  style={{
                    position: 'absolute',
                    top: '-20px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {selected} {unit ?? ''}
                </div>

                <input
                  type="range"
                  min={min}
                  max={max}
                  step={step}
                  value={selected ?? min}
                  onChange={this.handleChange}
                />
              </div>

              <RangeLabels>
                <span style={{ whiteSpace: 'nowrap' }}>
                  {max} {unit ?? ''}
                </span>
              </RangeLabels>
            </div>
          </Content>
        </Container>
      </Spin>
    );
  }
}

export default withTranslation(RangeEdit);
